// The quiz half of the site is English-only (no i18n). All its UI strings live
// here as plain constants so they never route through react-i18next. Reused
// trivia (the loading facts) is pulled in English via i18n.getFixedT('en').

export const QUIZ_COPY = {
  // Home + header flow-switch buttons
  getToClass: 'Get to Class',
  getYourIdCard: 'Get Your ID Card',

  // Picker (start + "quiz again" — same screen)
  startTitle: 'Ready to test your Off Campus knowledge?',
  againTitle: 'Ready to take another quiz?',
  pickPrompt: 'Choose which episode you are ready to be quizzed on:',
  firstName: 'First Name',
  lastName: 'Last Name',
  startQuiz: 'Start Quiz',
  studentId: 'Student ID',
  nameError: 'Please enter a different name.',

  // Question screen
  goBack: 'Go Back',
  next: 'Next',

  // Loading / processing
  loadingTitle: 'Please hold.',
  loadingSubtitle: "We're gathering your results.",

  // Results
  resultsTitle: 'Your Quiz Results are Ready!',
  resultsSubtitle: 'Download and share this to connect with your fellow Briar U classmates.',
  takeAnother: 'Take Another Quiz',
  download: 'Download',
  share: 'Share Your Grade',

  // Report card
  takenBy: 'Taken By:',
  professorCommentary: 'Professor Commentary:',

  // Confirm dialogs
  quitTitle: 'Quit this quiz?',
  quitBody: 'Your progress will be lost and this quiz will start over.',
  switchTitle: 'Leave this page?',
  switchBody: 'Your progress here will be lost.',
  confirmYes: 'Yes, leave',
  confirmNo: 'Stay',
} as const;

const EPISODE_WORDS: Record<number, string> = {
  2: 'Two',
  3: 'Three',
  4: 'Four',
  5: 'Five',
  6: 'Six',
  7: 'Seven',
  8: 'Eight',
};

/** Spelled-out episode number for the report card ("Episode Two"). */
export function episodeWord(n: number): string {
  return EPISODE_WORDS[n] ?? String(n);
}
